import { Component, Vue } from 'vue-property-decorator';
import LogoBar from '@/components/LogoBar/LogoBar'

@Component<Concept>({
  components: {
    LogoBar,
  },
})
export default class Concept extends Vue {
  protected isScrolled: boolean = false;

  public mounted() {
    //
  }

  public created() {
    window.addEventListener('scroll', this.checkScroll);
  }

  public destroyed() {
    window.removeEventListener('scroll', this.checkScroll);
  }

  protected checkScroll() {
    const scrollObject = {
      y: window.pageYOffset
    }
    
    if (scrollObject.y > 30) this.isScrolled = true;
    if (scrollObject.y < 30) this.isScrolled = false;
  }

}
